import React from 'react';
import { PageHead, Section, Eyebrow, PageTitle, Lede, SectionHead } from '../components/ui';

const PRIVACY_MAILTO = 'mailto:srini@rightbrainlabs.ai?subject=Privacy';

/** Privacy. What the site collects, what our own tools read, and how to have it removed. */
const Block = ({ title, children }) => (
  <div className="mt-12 first:mt-0">
    <SectionHead as="h2">{title}</SectionHead>
    {children}
  </div>
);

const P = ({ children }) => <p className="prose-rbl mt-4">{children}</p>;

const PrivacyPage = () => (
  <>
    <PageHead title="Privacy" description="What Right Brain Labs collects, why, and how to have it removed." path="/privacy" />
    <Section tone="page" reveal={false}>
      <Eyebrow>Privacy</Eyebrow>
      <PageTitle>What we collect, and what we do with it.</PageTitle>
      <Lede>Right Brain Labs collects very little, sells nothing, and deletes on request. Last updated September 24, 2026.</Lede>
    </Section>
    <Section tone="card">
      <Block title="Browsing the site">
        <P>This site sets no tracking cookies and runs no analytics or advertising scripts. It is hosted on Amazon Web Services, which keeps standard server logs. Fonts load from Google Fonts, which receives your IP address when your browser requests them.</P>
      </Block>
      <Block title="The CoThink Compass">
        <P>To take the Compass you give us your name, email address, and job title. We store those with your answers and your score on Amazon Web Services in the United States, and we email your report to you through Amazon's email service. That is the only email the Compass sends. We do not add you to a mailing list.</P>
        <P>If you start the Compass and do not finish, that session is deleted automatically after seven days. Completed results are kept so you can compare a later attempt with an earlier one, until you ask us to delete them.</P>
      </Block>
      <Block title="Email">
        <P>When you write to us, your message sits in our Google Workspace mailbox and is used only to reply to you.</P>
      </Block>
      <Block title="Our own tools and Google data">
        <P>Right Brain Labs runs internal software that reads its founder's own Google calendars and inbox, with read-only access, to prepare a daily briefing for him. It connects only to Google accounts that belong to him. It is not offered to the public, and no one else can sign in to it.</P>
        <P>The Google data it reads is used only to prepare that briefing. Most of it is processed on computers Right Brain Labs owns. Some steps may use Anthropic's Claude, under terms that do not allow the data to be used to train models. The data is not sold, not shared with anyone else, not used for advertising, and not used to train AI models.</P>
        <P>Right Brain Labs' use and transfer of information received from Google APIs adheres to the <a className="text-emerald-600 hover:text-emerald-500 dark:text-emerald-300 underline" href="https://developers.google.com/terms/api-services-user-data-policy" target="_blank" rel="noopener noreferrer">Google API Services User Data Policy</a>, including the Limited Use requirements.</P>
      </Block>
      <Block title="Your choices">
        <P>To see what we hold about you, correct it, or have it deleted, email <a className="text-emerald-600 hover:text-emerald-500 dark:text-emerald-300 underline" href={PRIVACY_MAILTO}>srini@rightbrainlabs.ai</a>. We answer within 30 days, usually much sooner.</P>
        <P>Right Brain Labs LLC, New Albany, Ohio.</P>
      </Block>
    </Section>
  </>
);

export default PrivacyPage;
